export enum RequestStatus {
  Pending = "Pending",
  Resolved = "Resolved",
}

export enum ResolvedRequestStatus {
  Approved = "approved",
  Denied = "denied",
}
